import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=1f394e74&scoped=true&lang=html"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f394e74",
  null
  
)

export default component.exports